import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/system';
import { useSelector } from 'react-redux';

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: '#fff'
}));

export default function SimpleBackdrop() {
  const { open } = useSelector(s => s.backdrop);

  if (!open) {
    return null;
  }

  return (
    <div>
      <StyledBackdrop open={open}>
        <CircularProgress color="inherit" />
      </StyledBackdrop>
    </div>
  );
}
